module.exports = "<div class=\"info\">  <span>Info:</span> {{info}}</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/info/info.component.html
// module id = ./src/app/info/info.component.html
// module chunks = main